import {getShowRecordPopover} from '/component/screen/report/withRecordPopover';
import {CLIENT_REPORT, COACH_REPORT} from '/enum/popover.enum';
import {MY_TEAMS, REPORT_ALL_ORGANIZATION_CLIENTS} from '/enum/records.enum';
import {
  SEARCH_CARD_CLIENT_CONTENT,
  SEARCH_CARD_COACHES_CONTENT,
} from '/enum/reportCard.enum';

/**
 * According to api documentation:
 * customerTypeId 1 = coach
 * customerTypeId 2 = client
 */

const POPOVERS = {
  1: {
    //Temporarily use the endpoint of these reports for fetching data
    recordsName: MY_TEAMS,
    popoverContentName: SEARCH_CARD_COACHES_CONTENT,
    popoverName: COACH_REPORT,
  },
  2: {
    //Temporarily use the endpoint of these reports for fetching data
    recordsName: REPORT_ALL_ORGANIZATION_CLIENTS,
    popoverContentName: SEARCH_CARD_CLIENT_CONTENT,
    popoverName: CLIENT_REPORT,
  },
};

/**
 * Generates callback to display record popover when info icon is pressed
 *
 * @param {object} params - Parameters
 * @param {function} params.item - An information about record
 * @param {function} params.recordsShowPopover - A callback to show popover
 * @param {function} params.recordsShowRecord - A callback to show record
 * @param {function} params.onOrderPress - A callback to show order information
 *
 * @returns {function} Callback - A function to be called when item is pressed
 */

export function generateOnRecordPress({
  item,
  recordsShowPopover,
  recordsShowRecord,
  onOrderPress,
}: any) {
  const {customerTypeId, id} = item;
  const {recordsName, popoverContentName, popoverName} =
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    POPOVERS[customerTypeId];

  const showRecordPopover = getShowRecordPopover({
    reportPayload: {recordsName},
    popoverContentName,
    popoverName,
  });

  return () =>
    showRecordPopover([id], {
      recordsShowPopover,
      recordsShowRecord,
      onOrderPress,
    });
}
